import http from '@/requests/http'
import utilityHelper from '@/helpers/utils'

class Manager {
  static findAll (params) {
    return http.post('management/manager', params)
  }
  static getInfoByCompany (params) {
    return http.post('management/manager/get-info-by-company', params)
  }
  static async store (params) {
    const formData = new FormData()

    await utilityHelper.buildFormData(formData, params)

    return http.post('management/manager/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static view (params) {
    return http.post('management/manager/view', params)
  }
  static async update (params) {
    const formData = new FormData()

    await utilityHelper.buildFormData(formData, params)

    return http.post('management/manager/update', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static destroy (params) {
    return http.post('management/manager/destroy', params)
  }
}

export default Manager
